<template>
  <div>
    <h3>Hasil Testing</h3>
    <McBadge :text="text" :variant="variant" :size="size" :type="type"></McBadge>
    <h3 class="mt-4">Contoh :</h3>
    <h5>Badge Bold</h5>
    <div class="my-3">
      <McBadge text="Small" variant="success" size="small" type="button"></McBadge>
      <McBadge text="Medium" variant="success" size="medium" type="button" class="mx-2"></McBadge>
      <McBadge text="Large" variant="success" size="large" type="button"></McBadge>
    </div>
    <h5>Badge Pill</h5>
    <div class="my-3">
      <McBadge text="Small" variant="success" size="small" type="pill"></McBadge>
      <McBadge text="Medium" variant="success" size="medium" type="pill" class="mx-2"></McBadge>
      <McBadge text="Large" variant="success" size="large" type="pill"></McBadge>
    </div>
    <h5>Badge Minimal</h5>
    <div class="my-3">
      <McBadge text="Minimal" variant="success" type="status"></McBadge>
    </div>
    <h5>Notification</h5>
    <div class="my-3 position-relative" style="height: 30px">
      <McBadge text="Small" size="small" type="notif" variant="danger"></McBadge>
    </div>
    <div class="my-2 position-relative" style="height: 30px">
      <McBadge text="Medium" size="medium" type="notif" variant="danger"></McBadge>
    </div>
    <div class="my-2 position-relative" style="height: 30px">
      <McBadge text="Large" size="large" type="notif" variant="danger"></McBadge>
    </div>
  </div>
</template>
  <script>
import McBadge from './index'

export default {
  components: {
    McBadge,
  },

  props: {
    text: {
      type: String,
    },
    variant: {
      type: String,
    },
    size: {
      type: String,
    },
    type: {
      type: String,
      default: 'button',
      required: true,
    },
  },
}
</script>
  